import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ctaSection.css';

const CTASection = ({ 
  title, 
  subtitle, 
  galleryLink, 
  showEmergency = false,
  customNote = null,
  className = '',
  showButtons = true
}) => {
  return (
    <section className={`cta-section ${className}`}>
      <div className="cta-container">
        <div className="cta-inner">
          <h2 className="cta-title">{title}</h2>
          {subtitle && <p className="cta-subtitle">{subtitle}</p>}
          
          {showButtons && (
            <div className="cta-buttons">
              <a
                className="btn-cta"
                href="mailto:info@allseasons.info"
                target="_blank"
                rel="noopener noreferrer"
              >
                REQUEST A CONSULTATION
              </a>
              <Link to={galleryLink} className="btn-primary">
                GALLERY
              </Link>
            </div>
          )}
          
          {/* {showEmergency && (
            <p className="cta-emergency">
              EMERGENCY SERVICE AVAILABLE • CALL (208) 450-9676
            </p>
          )} */}
          
          {customNote && (
            <p className="cta-note">
              {customNote}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASection;